<template>
  <div class="overview">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card>
          <div class="card-header">
            <span>在线终端数量</span>
          </div>
          <div class="card-body">
            <h2>{{ bracelets.filter(b => b.status !== '电量低').length }}</h2>
            <p>个</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div class="card-header">
            <span>基站在线率</span>
          </div>
          <div class="card-body">
            <h2>100%</h2>
            <p>在线</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div class="card-header">
            <span>今日使用量</span>
          </div>
          <div class="card-body">
            <h2>{{ bracelets.filter(b => b.status === '使用中').length }}</h2>
            <p>次</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div class="card-header">
            <span>通知数量</span>
          </div>
          <div class="card-body">
            <h2>{{ bracelets.filter(b => b.battery < 20).length }}</h2>
            <p>条</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chart-row">
      <el-col :span="12">
        <el-card>
          <h3>终端使用趋势</h3>
          <div ref="braceletChart" class="chart"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <h3>标签使用统计</h3>
          <div ref="bookChart" class="chart"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <h3>未使用终端</h3>
          <div class="unused-bracelets">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" @click="handleBorrow">出借终端</el-button>
                <el-button type="danger" @click="handleReturn">归还终端</el-button>
              </el-col>

              <el-col :span="12">
                <el-input
                  v-model="searchQuery"
                  placeholder="搜索终端 ID"
                  clearable
                  @clear="handleSearchClear"
                  @input="searchDebounce"
                />
                <div v-if="searchQuery" style="margin-top: 8px; font-size: 12px; color: #909399;">
                  匹配终端数量: {{ unusedBracelets.length }}
                </div>
              </el-col>
            </el-row>

            <el-table :data="unusedBracelets" style="width: 100%; margin-top: 20px;" v-loading="loading">
              <template #empty>
                <el-empty description="未找到匹配的终端" />
              </template>
              <el-table-column prop="id" label="终端 ID" sortable />
              <el-table-column prop="battery" label="电量" sortable />
              <el-table-column label="操作">
                <template #default="scope">
                  <el-button type="text" @click="() => handleFindBracelet(scope.row)">找终端</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      v-model="dialogVisible"
      title="出借终端"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="选择终端">
          <el-select
            v-model="selectedBracelet"
            placeholder="请选择终端"
            filterable
          >
            <el-option
              v-for="bracelet in filteredBracelets"
              :key="bracelet.id"
              :label="`${bracelet.id} (电量: ${bracelet.battery}%)`"
              :value="bracelet.id"
            />
          </el-select>
          <el-button
            type="primary"
            @click="handleFindBraceletDialog"
          >
            找终端
          </el-button>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="userInfo.name" placeholder="请输入用户姓名" />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="userInfo.phone" placeholder="请输入用户电话" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="returnDialogVisible"
      title="归还终端"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="选择终端">
          <el-select
            v-model="selectedReturnBracelet"
            placeholder="请选择终端"
            filterable
          >
            <el-option
              v-for="bracelet in unreturnedBracelets"
              :key="bracelet.id"
              :label="`${bracelet.id} (距离: ${bracelet.distance}m)`"
              :value="bracelet.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="借出人">
          <el-input v-model="selectedBracelett.userName" disabled />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="selectedBracelett.userPhone" disabled />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="returnDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleReturnConfirm">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DataOverview',
  data() {
    return {
      dialogVisible: false,
      returnDialogVisible: false,
      selectedBracelet: null,
      selectedReturnBracelet: null,
      userInfo: {
        name: '',
        phone: ''
      },
      unreturnedBracelets: [],
      searchQuery: '',
      searchDebounce: null,
      // 图表数据
      braceletData: {
        xAxis: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        series: [120, 200, 150, 80, 70, 110, 130]
      },
      bookData: {
        categories: ['文学', '科技', '历史', '艺术', '其他'],
        series: [120, 200, 150, 80, 70]
      },
      // 终端管理数据 (预生成随机数据)
      bracelets: [
        { id: '001', battery: 95, status: '未使用', distance: 12, signal: -45, ip: '192.168.1.1', userName: '', userPhone: '', charging: false },
        { id: '002', battery: 60, status: '使用中', distance: 45, signal: -65, ip: '192.168.1.2', userName: '王芳', userPhone: '13987654321', charging: false },
        { id: '003', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '004', battery: 100, status: '未使用', distance: 67, signal: -50, ip: '192.168.1.4', userName: '', userPhone: '', charging: true },
        { id: '005', battery: 50, status: '使用中', distance: 3, signal: -70, ip: '192.168.1.5', userName: '赵强', userPhone: '13655667788', charging: false },
        { id: '006', battery: 85, status: '未使用', distance: 22, signal: -55, ip: '192.168.1.6', userName: '', userPhone: '', charging: true },
        { id: '007', battery: 40, status: '使用中', distance: 78, signal: -75, ip: '192.168.1.7', userName: '王伟', userPhone: '13311223344', charging: false },
        { id: '008', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '009', battery: 55, status: '未使用', distance: 50, signal: -60, ip: '192.168.1.9', userName: '', userPhone: '', charging: true },
        { id: '010', battery: 82, status: '未使用', distance: 18, signal: '89db', ip: '192.168.1.10', userName: '', userPhone: '', charging: true },
        { id: '011', battery: 33, status: '使用中', distance: 93, signal: '63db', ip: '192.168.1.11', userName: '李敏', userPhone: '13566778899', charging: false },
        { id: '012', battery: null, status: '离线', distance: null, signal: '未知', ip: null, userName: '', userPhone: '', charging: null },
        { id: '013', battery: 97, status: '未使用', distance: 7, signal: '92db', ip: '192.168.1.13', userName: '', userPhone: '', charging: false },
        { id: '014', battery: 45, status: '使用中', distance: 125, signal: '58db', ip: '192.168.1.14', userName: '陈超', userPhone: '13123456789', charging: false },
        { id: '015', battery: 76, status: '未使用', distance: 34, signal: '78db', ip: '192.168.1.15', userName: '', userPhone: '', charging: true },
        { id: '016', battery: null, status: '离线', distance: null, signal: '未知', ip: null, userName: '', userPhone: '', charging: null },
        { id: '017', battery: 28, status: '使用中', distance: 88, signal: '65db', ip: '192.168.1.17', userName: '周静', userPhone: '13755664433', charging: false },
        { id: '018', battery: 91, status: '未使用', distance: 11, signal: '93db', ip: '192.168.1.18', userName: '', userPhone: '', charging: false },
        { id: '019', battery: 55, status: '使用中', distance: 62, signal: '72db', ip: '192.168.1.19', userName: '吴勇', userPhone: '13900112233', charging: false },
        { id: '020', battery: null, status: '离线', distance: null, signal: '未知', ip: null, userName: '', userPhone: '', charging: null },
        { id: '021', battery: 100, status: '未使用', distance: 2, signal: '98db', ip: '192.168.1.21', userName: '', userPhone: '', charging: true },
        { id: '022', battery: 39, status: '使用中', distance: 107, signal: '60db', ip: '192.168.1.22', userName: '孙丽', userPhone: '13800998877', charging: false },
        { id: '023', battery: 84, status: '未使用', distance: 29, signal: '84db', ip: '192.168.1.23', userName: '', userPhone: '', charging: false },
        { id: '024', battery: 63, status: '使用中', distance: 74, signal: '68db', ip: '192.168.1.24', userName: '郑杰', userPhone: '13612341234', charging: false },
        { id: '025', battery: null, status: '离线', distance: null, signal: '未知', ip: null, userName: '', userPhone: '', charging: null },
        { id: '026', battery: 95, status: '未使用', distance: 14, signal: '90db', ip: '192.168.1.26', userName: '', userPhone: '', charging: true },
        { id: '027', battery: 47, status: '使用中', distance: 83, signal: '62db', ip: '192.168.1.27', userName: '王杰', userPhone: '13943214321', charging: false },
        { id: '028', battery: 79, status: '未使用', distance: 41, signal: '79db', ip: '192.168.1.28', userName: '', userPhone: '', charging: false },
        { id: '029', battery: 58, status: '使用中', distance: 96, signal: '70db', ip: '192.168.1.29', userName: '林涛', userPhone: '13567896789', charging: false },
        { id: '030', battery: null, status: '离线', distance: null, signal: '未知', ip: null, userName: '', userPhone: '', charging: null },
        { id: '031', battery: 88, status: '未使用', distance: 55, signal: '87db', ip: '192.168.1.31', userName: '', userPhone: '', charging: true },
        { id: '032', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null }
      ],
      searchQuery: '',
      selectedBracelets: [], // 初始化 selectedBracelets
      filteredBracelets: [] // 初始化 filteredBracelets
    };
  },
  mounted() {
    // // 预定义的姓氏和名字列表
    // const lastNames = ['张', '王', '李', '赵', '刘'];
    // const firstNames = ['伟', '芳', '敏', '强', '丽'];

    // // 为每个终端生成随机距离数据和借出人信息
    // this.bracelets = this.bracelets.map(bracelet => ({
    //   ...bracelet,
    //   distance: Math.floor(Math.random() * 100) + 1, // 生成 1 到 100 米的随机距离
    //   userName: lastNames[Math.floor(Math.random() * lastNames.length)] + 
    //             firstNames[Math.floor(Math.random() * firstNames.length)], // 随机生成姓名
    //   userPhone: '1' + Math.floor(Math.random() * 10000000000).toString().padStart(10, '0') // 随机生成 11 位电话号码
    // }));
    this.initCharts();
  },
  computed: {
    selectedBracelett() {
      return this.bracelets.find(b => b.id === this.selectedReturnBracelet)
    },
    unusedBracelets() {
      let bracelets = this.bracelets.filter(bracelet => bracelet.status === '未使用' && bracelet.battery >= 20);
      if (this.searchQuery) {
        bracelets = bracelets.filter(bracelet => bracelet.id.includes(this.searchQuery));
      }
      return bracelets;
    },
    onlineBracelets() {
      return this.bracelets.filter(b => b.status !== '电量低').length;
    },
    borrowedBooks() {
      return this.bracelets.filter(b => b.status === '使用中').length;
    },
    lowBatteryNotifications() {
      return this.bracelets.filter(b => b.battery < 20).length;
    }
  },
  methods: {
    getItemById(id) {
      return this.items.find(item => item.id === id);
    }
  },
  methods: {
    handleBorrow() {
      // 获取所有未借出的终端并按电量降序排序
      this.filteredBracelets = this.bracelets
        .filter(bracelet => bracelet.status === '未使用' && bracelet.battery >= 20)
        .sort((a, b) => b.battery - a.battery);
      
      // 自动选择电量最高的终端
      this.selectedBracelet = this.filteredBracelets[0].id || null;
      this.dialogVisible = true;
    },
    handleDialogConfirm() {
      if (!this.selectedBracelet) {
        this.$message.warning('请选择要出借的终端');
        return;
      }
      if (!this.userInfo.name || !this.userInfo.phone) {
        this.$message.warning('请输入完整的用户信息');
        return;
      }
      this.$message.success(`终端 ${this.selectedBracelet} 已出借给 ${this.userInfo.name}`);
      this.dialogVisible = false;
    },
    handleFindBraceletDialog() {
      if (this.selectedBracelet) {
        this.$message.success(`目标终端 ${this.selectedBracelet} 正在响铃`);
      } else {
        this.$message.warning('请先选择终端');
      }
    },
    handleReturn() {
      this.returnDialogVisible = true;
      // 加载所有未归还的终端
      this.unreturnedBracelets = this.bracelets.filter(bracelet => bracelet.status === '使用中');
      // 按距离排序
      this.unreturnedBracelets.sort((a, b) => a.distance - b.distance);
      // 自动选择最近的终端
      this.selectedReturnBracelet = this.unreturnedBracelets[0].id;
    },
    handleReturnConfirm() {
      if (!this.selectedReturnBracelet) {
        this.$message.warning('请选择要归还的终端');
        return;
      }
      this.$message.success(`终端 ${this.selectedReturnBracelet} 已成功归还`);
      this.returnDialogVisible = false;
    },
    handleFindBracelet(bracelet) {
      this.$message.success(`目标终端 ${bracelet.id} 正在响铃`);
    },
    handleSearchClear() {
      this.searchQuery = '';
    },
    handleEdit(row) {
      this.$message.info(`编辑终端 ${row.id}`);
    },
    initCharts() {
      // 初始化终端使用趋势图
      const braceletChart = this.$echarts.init(this.$refs.braceletChart);
      braceletChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            return `日期: ${params[0].name}<br>使用量: ${params[0].value}`;
          }
        },
        xAxis: {
          type: 'category',
          data: this.braceletData.xAxis,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '使用量'
        },
        series: [{
          data: this.braceletData.series,
          type: 'line',
          smooth: true,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(64, 158, 255, 0.8)'
              }, {
                offset: 1, color: 'rgba(64, 158, 255, 0)'
              }]
            }
          }
        }]
      });

      // 初始化书籍借阅统计图
      const bookChart = this.$echarts.init(this.$refs.bookChart);
      bookChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}: ${params.value} (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.bookData.categories
        },
        series: [
          {
            name: '借阅量',
            type: 'pie',
            radius: '50%',
            data: this.bookData.categories.map((name, index) => ({
              name,
              value: this.bookData.series[index]
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              show: true,
              formatter: '{b}: {c} ({d}%)'
            }
          }
        ]
      });

      // 动态更新数据
      setInterval(() => {
        const newSeries = this.braceletData.series.map(value => value + Math.floor(Math.random() * 20));
        braceletChart.setOption({
          series: [{
            data: newSeries
          }]
        });
      }, 5000);
    }
  }
};
</script>

<style scoped>
.overview {
  padding: 20px;
}

.el-row {
  margin-bottom: 20px;
}

.card-header {
  font-size: 14px;
  color: #909399;
  margin-bottom: 10px;
}

.card-body {
  text-align: center;
}

.card-body h2 {
  font-size: 24px;
  color: #303133;
  margin: 10px 0;
}

.card-body p {
  color: #909399;
  font-size: 12px;
}

.chart {
  height: 300px;
}
</style>
